export default "__VITE_ASSET__d88e5364__"